import { useMutation } from 'react-query';
import { isBillingSearchFormEmpty } from 'src/components/Common/UI/SydFilter/SydFilterTypeChecker';
import { filterNonEmptyValues, isObjectEmpty } from 'src/helpers/AppCode';
import { axiosDefaultApi } from 'src/lib/axios'
import { MutationConfig} from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';

const emptyBillingSummaryReport: IGetBillingSummaryReport = {
  detailsData: [],
  linesData: [],
  linesDataFooter: {
    onceFees: 0,
    monthlyFees: 0,
    usageFees: 0,
    totalFees: 0,
    posoFpa: 0,
    actualFees: 0
  }
}

const mapFilterData = (data: IBillingSummarySearchForm): IBillingSummarySearchPost | {} => {
  if (isBillingSearchFormEmpty(data) || data == undefined) { return {} };
  const removedUnusedFilters = filterNonEmptyValues(data);
  return removedUnusedFilters;
}

const convertDataForReport = (data: IGetBillingSummaryReportApi): IGetBillingSummaryReport => {
  return {
    detailsData: [{...data.summaryPhoneLinesDataDto}],
    linesData: data.getSummaryPhoneLinesDto,
    linesDataFooter: data.totalsSummaryPhoneLinesDto
  }
}

const getBillingSummaryReport = async ( {data} : {data: IBillingSummarySearchForm}): Promise<IGetBillingSummaryReport> => {
  const filterData = mapFilterData(data);

  if(isObjectEmpty(filterData)){
    return emptyBillingSummaryReport;
  }
  
  const response =  await axiosDefaultApi.post<IGetBillingSummaryReportApi>(`api/billing/summary`, filterData);
  const convertedResponse = convertDataForReport(response as unknown as IGetBillingSummaryReportApi);
  return convertedResponse as unknown as IGetBillingSummaryReport;
};

type QueryFnType = typeof getBillingSummaryReport;

type UseGetBillingSummaryReportOptions = {
  data: IBillingSummarySearchForm;
  config?: MutationConfig<QueryFnType>;
};

export const useGetBillingSummaryReport = ({config}: UseGetBillingSummaryReportOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();

  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των χρεωσεων.`, 500);
      setIsNotificationVisible(true);
      console.log(error);
    },
    ...config,
    mutationFn: getBillingSummaryReport,
  });
};